<template>
    <div class="datepicker form-group">
        <label
            :for="uniqueId"
            class="form-group-label d-flex align-items-center"
        >
            {{ label }}

            <ui-icon
                v-if="tooltip"
                icon="info"
                :content="tooltip"
                class="ml-2"
                v-tippy
            />
        </label>
        <v-date-picker
            v-model="inputValue"
            mode="single"
            timezone="UTC"
        >
            <template v-slot="{ inputValue, inputEvents }">
                <div class="input-group">
                    <div class="position-relative d-flex flex-column w-100">
                        <input
                            v-on="inputEvents"
                            :placeholder="placeholder"
                            :value="inputValue"
                            class="form-control"
                        >
                        <ui-icon
                            icon="calendar"
                            class="datepicker-icon"
                        />
                    </div>
                </div>
            </template>
        </v-date-picker>

        <input
            type="text"
            :id="uniqueId"
            :name="name"
            :required="required"
            :value="ISOString"
            class="datepicker-input visually-hidden"
        >
    </div>
</template>

<script>
    import dayjs from 'dayjs';

    import UiIcon from './icon.vue';

    export default {
        name: 'UiDatePicker',
        components: {
            UiIcon,
        },
        props: {
            disabled: {
                type: Boolean,
                default: false,
            },
            label: {
                type: String,
                default: null,
            },
            name: {
                type: String,
                default: 'date',
            },
            placeholder: {
                type: String,
                default: '',
            },
            readonly: {
                type: Boolean,
                default: false,
            },
            required: {
                type: Boolean,
                default: false,
            },
            tooltip: {
                type: String,
                default: null,
            },
            value: {
                type: String,
                default: null,
            },
        },
        data() {
            return {
                inputValue: this.value ? dayjs(this.value).toDate() : null,
            };
        },
        computed: {
            ISOString() {
                if (!this.inputValue) {
                    return null;
                }

                return dayjs(this.inputValue).toISOString();
            },

            uniqueId() {
                return `datepicker-${this._uid}`;
            },
        },
        watch: {
            inputValue() {
                this.$emit('input', this.ISOString);
            },

            value() {
                this.inputValue = dayjs(this.value).toDate();
            },
        },
    };
</script>
